import React from "react";

import {project} from "../project";
import { Link } from "react-router-dom";
import "./Projects.css";

const Projects = () => {

  return (
    <main>
    <div class="mainBody">
      <div class="bannerBlock4">
        <div
          style={{
            position: "absolute",
            right: "0px",
            width: "250px",
            height: "150px",
            backgroundposition: "-0px -100px",
          }}
        >
          <img src={require("../images/Services.png")} />{" "}
        </div>
        <div class="bannerContent">
          <div class="content">
            <span class="pageTitle">Success Stories: Delivering Business Value</span>
            <br />
            <span class="subTitle">
              Proven results that drive measurable impact: <br />
              cost reduction, faster time-to-market, and strategic transformation
            </span>
          </div>
        </div>
      </div>

      <div>
      {project.map((data, index) => {

                return <div key={index} class="content padSmall">
                <div class="proLogo">
                  {data.image && (
                    <div class="cLogo">
                      <img src={data.image} alt={data.title} />
                    </div>
                  )}
                  <div class="pDesc">
                    <span class="subTitle1">
                      <b>{data.title}</b>
                    </span>
                    <br></br>
                    <p>
                      <b>{data.description}</b>
                    </p>

                 <Link to="/projectdetail" state={{ title: data.title,
                 description: data.description,
                 image : data.image,
                 highlites: data.highlites,
                 architecture: data.architecture
                }}>
                 <div class="productbutton">Learn More</div>
                 </Link>

                  </div>
                </div>
        
             </div> 
         })}
      </div>
    </div>
    <div style={{ clear: "both" }}></div>
  </main>
  );
};

export default Projects;
